export default class Sticky {
  constructor($ele) {
    let selector = $ele.data('sticky-target');
    this._ele = $ele;
    this._target = $(selector);
    this._eventTarget = $('.section.event');
    this.$window = $(window);
    this._isSticky = false;
    this._isScrollEvt = false;
  }

  scroll() {
    let scrollTop = this.$window.scrollTop();
    let scrollBottom = scrollTop + this.$window.height();
    let targetOffsetTop = this._target.offset().top;

    if (scrollBottom >= targetOffsetTop) {
      // let gap = scrollBottom - targetOffsetTop;
      this.on();
    } else {
      this.off();
    }

    /*let evtTop = this._eventTarget.offset().top + (this._eventTarget.height() >> 1);
        if (scrollBottom > evtTop) {
            this.down();
        } else {
            this.up();
        }*/
  }

  on() {
    if (this._isSticky) return;
    this._ele.css({
      position: 'absolute',
    });
    this.down();
    this._isSticky = true;
  }

  off() {
    if (!this._isSticky) return;
    this._ele.css({
      position: 'fixed',
    });
    this.up();
    this._isSticky = false;
  }

  down() {
    if (this._isScrollEvt) return;
    TweenMax.to(this._ele.find('.arrow'), 0.6, { rotation: 180 });
    this._isScrollEvt = true;
  }

  up() {
    if (!this._isScrollEvt) return;
    TweenMax.to(this._ele.find('.arrow'), 0.6, { rotation: 0 });
    this._isScrollEvt = false;
  }
}
